import { render } from "./DownloadComponent.vue?vue&type=template&id=eea4fc2c"
import script from "./DownloadComponent.vue?vue&type=script&lang=js"
export * from "./DownloadComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__